import { type ColorGroup } from '@lib/colors/colors'
import {
  Bethany,
  Charlie,
  Dan,
  Devon,
  Jorge,
  Lin,
  Lucia,
  Tanisha,
} from '@modules/images/pages/for-research-coordinators'
import { type PatientProps } from './patientRequestCard'

export const patientList: PatientProps[] = [
  {
    age: '30',
    badge: 'Not Contacted Yet',
    colorGroup: 'warm' as ColorGroup,
    condition: 'Depression',
    img: Devon,
    location: 'Chicago, IL',
    name: 'Devon',
    tag: 'EMR available',
  },
  {
    age: '52',
    badge: 'Contacted',
    colorGroup: 'green' as ColorGroup,
    condition: 'Type 2 Diabetes',
    img: Jorge,
    location: 'New York, NY',
    name: 'Jorge',
    tag: 'BMI 26',
  },
  {
    age: '57',
    badge: 'Response Required',
    colorGroup: 'turquoise' as ColorGroup,
    condition: 'Breast Cancer',
    img: Bethany,
    location: 'Chicago, IL',
    name: 'Bethany',
    tag: 'EMR available',
  },
  {
    age: '51',
    badge: 'Contacted',
    colorGroup: 'green' as ColorGroup,
    condition: 'Kidney Cancer',
    img: Charlie,
    location: 'California,CA',
    name: 'Charlie',
    tag: 'Non-smoker',
  },
  {
    age: '68',
    badge: 'Not contacted yet',
    colorGroup: 'warm' as ColorGroup,
    condition: 'Lupus',
    img: Tanisha,
    location: 'California,CA',
    name: 'Tanisha',
    tag: 'EMR available',
  },
  {
    age: '36',
    badge: 'Response Required',
    colorGroup: 'turquoise' as ColorGroup,
    condition: 'Multiple Myeloma',
    img: Dan,
    location: 'Miami, FL',
    name: 'Dan',
    tag: 'ECOG Score of 3',
  },
  {
    age: '83',
    badge: 'Contacted',
    colorGroup: 'green' as ColorGroup,
    condition: `Alzheimer's`,
    img: Lucia,
    location: 'Houston,TX',
    name: 'Lucia',
    tag: 'MMSE Score of 22',
  },
  {
    age: '34',
    badge: 'Contacted',
    colorGroup: 'green' as ColorGroup,
    condition: `Crohn's Disease`,
    img: Lin,
    location: 'Houston,TX',
    name: 'Lin',
    tag: '3+ Years Colitis',
  },
]
